import debug from 'debug';

function debugPouch(PouchDB) {
  PouchDB.debug = debug;
  var logs = {};
  /* istanbul ignore next */
  PouchDB.on('debug', function (args) {
    // first argument is log identifier
    var logId = args[0];
    // rest should be passed verbatim to debug module
    var logArgs = args.slice(1);
    if (!logs[logId]) {
      logs[logId] = debug('pouchdb:' + logId);
    }
    logs[logId].apply(null, logArgs);
  });
}

export default debugPouch;



//////////////////
// WEBPACK FOOTER
// ./~/pouchdb-debug/lib/index-browser.es.js
// module id = 2710
// module chunks = 0